module.exports = "pegasus/assets/blocks/column-17-theme2.png";